import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Gift, Flame, CheckCircle2 } from 'lucide-react';
export function PurchaseSection() {
  const [timeLeft, setTimeLeft] = useState({
    minutes: 30,
    seconds: 0
  });
  const [country, setCountry] = useState<string | null>(null);
  useEffect(() => {
    fetch('https://ipapi.co/json/').then(res => res.json()).then(data => {
      setCountry(data.country_code);
    }).catch(err => {
      console.error('Error fetching geolocation:', err);
      setCountry('US'); // Fallback to USD
    });
  }, []);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let {
          minutes,
          seconds
        } = prev;
        seconds -= 1;
        if (seconds < 0) {
          seconds = 59;
          minutes -= 1;
        }
        if (minutes < 0) {
          minutes = 0;
          seconds = 0;
        }
        return {
          minutes,
          seconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const pad = (n: number) => n.toString().padStart(2, '0');
  return <section id="comprar" className="py-14 sm:py-18 px-4 sm:px-6 lg:px-8 bg-deco-coral relative overflow-hidden scroll-mt-10" data-id="element-123" data-mp="176jh3k7hjfqo">
      {/* Decorative background */}
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-deco-ruby/10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/3" data-id="element-124" data-mp="1c77i8ypfhcym"></div>
      <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-deco-amber/20 rounded-full blur-3xl translate-y-1/3 -translate-x-1/3" data-id="element-125" data-mp="1l62q0f84ev41"></div>
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-white/10 rounded-full blur-3xl" data-id="element-126" data-mp="1pycedqtl7n47"></div>

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-127" data-mp="1zv79s0ukd7e9">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center" data-id="element-128" data-mp="1zws3xpcyuobl">
          {/* Urgency badge */}
          <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm text-white px-5 py-2 rounded-full text-sm font-bold uppercase tracking-wider mb-8 border border-white/20" data-id="element-129" data-mp="1a7utlj921e8l">
            <Flame size={16} data-id="element-130" data-mp="1k4zfrj2wh9pe" />
            Oferta por tiempo limitado
          </div>

          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold leading-tight mb-6 text-white" data-id="element-131" data-mp="1xwe2o0zxhv1q">
            Accedé hoy a{' '}
            <span className="font-script text-4xl sm:text-5xl lg:text-6xl font-normal" data-id="element-132" data-mp="1swrmbioszyop">
              Falso Vitral
            </span>{' '}
            Deco
          </h2>

          {/* Countdown */}
          <div className="flex items-center justify-center gap-3 mb-10" data-id="element-133" data-mp="22x2137qhle5z">
            <span className="text-white/80 font-semibold text-sm sm:text-base uppercase tracking-wider" data-id="element-134" data-mp="dgaq3y2ogurm">
              Esta oferta termina en
            </span>
            <div className="flex items-center gap-1.5 font-mono text-lg sm:text-xl font-bold" data-id="element-135" data-mp="8jsqfcm7fmm5">
              <span className="bg-white text-deco-terra rounded-lg px-3 py-2 min-w-[48px] text-center shadow-lg" data-id="element-136" data-mp="2k75wc48buafy">
                {pad(timeLeft.minutes)}
              </span>
              <span className="text-white text-2xl font-bold" data-id="element-137" data-mp="2aeqfxbcohtx6">:</span>
              <motion.span key={`ps-${timeLeft.seconds}`} initial={{
              scale: 1.1
            }} animate={{
              scale: 1
            }} transition={{
              duration: 0.15
            }} className="bg-white text-deco-terra rounded-lg px-3 py-2 min-w-[48px] text-center shadow-lg" data-id="element-138" data-mp="2fdkws7r358en">
                {pad(timeLeft.seconds)}
              </motion.span>
            </div>
          </div>

          {/* Price card */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="bg-white text-deco-text rounded-[2rem] sm:rounded-[3rem] p-8 sm:p-12 shadow-2xl max-w-xl mx-auto border border-deco-warm/50" data-id="element-139" data-mp="1wfqs25wzpj22">
            <div className="inline-flex items-center gap-2 bg-deco-coral/10 text-deco-coral px-4 py-1.5 rounded-full text-sm font-bold uppercase tracking-wider mb-8" data-id="element-140" data-mp="1lq2sr284rgwl">
              <Gift size={16} data-id="element-141" data-mp="1cqpgy2wjag8p" />
              Bonos incluidos solo por hoy
            </div>

            <div className="flex flex-col gap-3 mb-8 text-left w-full max-w-sm mx-auto bg-deco-bg/50 p-5 rounded-2xl border border-deco-coral/20 shadow-sm" data-id="element-142" data-mp="17tftutwmago1">
              {['Guía práctica Falso Vitral Deco', 'Plantillas para practicar', '+100 plantillas imprimibles', '+100 ideas para vender', 'Guía de emprendimiento'].map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-143" data-mp="u2kfx379h9dl" data-mpi={i}>
                  <CheckCircle2 size={18} className="text-deco-coral shrink-0 mt-0.5" data-id="element-144" data-mp="p269fplb67ho" />
                  <span className="text-deco-text/90 text-sm sm:text-base font-medium leading-tight" data-id="element-145" data-mp="k2a5trgiwi2n">
                    {item}
                  </span>
                </div>)}
            </div>

            <div className="flex flex-col items-center gap-2 mb-8" data-id="element-146" data-mp="30p039h4gp15d">
              <span className="text-xl text-deco-muted line-through font-serif decoration-deco-coral/50 decoration-2" data-id="element-147" data-mp="30rcny21ltpm4">
                {country === 'AR' ? '$39.990 ARS' : '$29.99 USD'}
              </span>
              <div className="flex items-baseline gap-2" data-id="element-148" data-mp="39nlq3ogyv2by">
                <span className="text-6xl sm:text-7xl font-bold text-deco-ruby font-serif leading-none" data-id="element-149" data-mp="2d0yuc73dfipf">
                  {country === 'AR' ? '$21.990' : '$14.99'}
                </span>
                <span className="text-2xl text-deco-taupe font-serif" data-id="element-150" data-mp="2lzav31xybwvl">
                  {country === 'AR' ? 'ARS' : 'USD'}
                </span>
              </div>
            </div>

            <motion.a href="https://falso-vitral-deco.impultienda.ar/checkout/falso-vitral-deco" target="_blank" rel="noopener noreferrer" whileHover={{
            scale: 1.03
          }} whileTap={{
            scale: 0.97
          }} animate={{
            boxShadow: ['0px 0px 0px 0px rgba(224,122,95,0.4)', '0px 0px 0px 15px rgba(224,122,95,0)', '0px 0px 0px 0px rgba(224,122,95,0)']
          }} transition={{
            duration: 2,
            repeat: Infinity,
            repeatType: 'loop'
          }} className="block w-full py-5 px-6 rounded-full bg-deco-coral text-white font-bold text-lg sm:text-xl uppercase tracking-wider hover:bg-deco-ruby transition-colors duration-300 shadow-xl text-center mb-6" data-id="element-151" data-mp="1u9zdxu9xzh7r">
              QUIERO ACCEDER AHORA
            </motion.a>

            <div className="flex items-center justify-center gap-2 text-xs sm:text-sm text-deco-taupe font-medium" data-id="element-152" data-mp="2rn98wo590mse">
              <ShieldCheck size={16} data-id="element-153" data-mp="2nlnzxdvu4snh" />
              <span data-id="element-154" data-mp="2nkmbm7pt69nt">Acceso inmediato · Producto digital · Pago seguro</span>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}